module.exports = __webpack_public_path__ + "src/assets/img/logo.5ccd3ce3.svg";